import { ProductDetail as ProductDetailComponent } from './ProductDetail.component';
import { connector } from './ProductDetail.connector';

export const ProductDetail = connector(ProductDetailComponent);
